<template>
    <div class="pagination" v-if="pagesCount > 1">
        <div class="pagination__prev" v-if="!isFirst" @click="emits('page', page - 1)">
            <button>
                <IconDef name="pagination-prev"></IconDef>
            </button>
        </div>

        <button class="pagination__btn" :class="{active: p === page}"
                v-for="p in pages" :key="pagesCount"
                @click="emits('page', p)"
        >
            {{ p }}
        </button>
        <!--        <button class="pagination__spacer">...</button>-->

        <div class="pagination__next" v-if="!isLast" @click="emits('page', page + 1)">
            <button>
                <IconDef name="pagination-next"></IconDef>
            </button>
        </div>
    </div>
</template>

<script setup>
import IconDef from "~/components/UI/IconDef.vue";

const emits = defineEmits(['page']);
const props = defineProps({
    count: {
        type: Number,
        required: true
    },
    page: {
        type: Number,
        default: 1
    },
    limit: {
        type: Number,
        default: 20
    }
});

const pagesCount = computed(() => Math.ceil(props.count / props.limit));
const isFirst = computed(() => props.page === 1);
const isLast = computed(() => props.page === pagesCount);
const start = computed(() => {
    let i = props.page - 2;
    if (i < 1) i = 1;
    return i;
});
const end = computed(() => {
    let i = start.value + 4;
    if (i > pagesCount.value) i = pagesCount.value;
    return i;
});

const pages = computed(() => {
    const arr = [];
    for (let i = start.value; i <= end.value; i++) {
        arr.push(i);
    }
    return arr;
});
</script>